import { fetchUsersInfoApi } from "../apis";
import { formatUserInfo } from "../adapter/formatUserData";

export default async function checkUser(force?: boolean) {
  // const auth = JSON.parse(localStorage.getItem("good-auth") || "{}");
  const user = JSON.parse(localStorage.getItem("good-user") || "{}");
  if (!force && user.id) {
    return {
      // auth,
      user,
    };
  } else {
    const res: any = await fetchUsersInfoApi();
    if (res.user) {
      // 在这里存入token和exp (参考sota)
      // const auth = {
      //   ...res.auth,
      // };
      const user = formatUserInfo(res.user);
      // localStorage.setItem("good-auth", JSON.stringify(auth));
      localStorage.setItem("good-user", JSON.stringify(user));
      return {
        // auth,
        user,
      };
    } else {
      return {
        // auth: {},
        user: {
          id: null,
        },
      };
    }
  }
}
